import React from 'react';

export const SquareArea = () => (
  <g
    transform="matrix(49.188563,0,0,49.188563,-0.48534152,2.0492808)"
    strokeWidth="0.02032993"
  >
    <path
      fill="#c2ccd8"
      strokeWidth="0.02032993"
      d="M 5.943,4.487 H 8.817 C 9.83,4.487 9.837,2.92 8.83,2.92 H 4.057 A 0.787,0.787 0 0 0 3.27,3.7 v 4.773 c 0,1.014 1.567,1.02 1.567,0.014 V 5.6 l 3.38,3.38 C 8.93,9.693 10.037,8.58 9.317,7.867 8.197,6.733 7.07,5.613 5.943,4.487 Z"
    />
    <path
      fill="#c2ccd8"
      strokeWidth="0.02032993"
      d="m 18.59,12.684 c 0,-1.013 -1.566,-1.02 -1.566,-0.013 v 2.887 l -3.38,-3.38 c -0.713,-0.714 -1.82,0.4 -1.1,1.113 l 3.374,3.373 h -2.874 c -1.013,0 -1.02,1.567 -0.013,1.567 h 4.773 a 0.787,0.787 0 0 0 0.787,-0.78 c 0.007,-1.587 0,-3.18 0,-4.767 z"
    />
    <path
      fill="#c2ccd8"
      strokeWidth="0.02032993"
      d="m 20.316,4.867 v 14.666 c 0,1.12 -2.74,0.714 -3.247,0.714 H 2.403 C 1.276,20.247 1.689,17.507 1.689,17 V 11.067 2.333 C 1.823,1.187 4.309,1.62 4.936,1.62 h 14.667 c 1.12,0 0.713,2.74 0.713,3.247 z m 1.5,-3.08 C 21.269,0.26 20.083,0.06 18.683,0.06 H 3.003 c -1.44,0 -2.56,0.553 -2.834,2.027 a 0.903,0.903 0 0 0 -0.04,0.24 0.87,0.87 0 0 0 0,0.186 v 8.547 c 0,2.887 -0.293,5.94 0.04,8.813 0.187,1.634 1.707,1.94 3.04,1.94 h 15.807 c 1.407,0 2.867,-0.6 2.867,-2.273 V 16.607 4.687 c 0,-0.834 0.226,-2.087 -0.067,-2.9 z"
    />
  </g>
);
